import * as yup from 'yup';
import { orgId, FieldValidation } from 'utils';

export default ({ externalIDMandatory, contactId }) => {
  const externalIDValidation = new FieldValidation();
  if (externalIDMandatory) {
    return {
      externalId: yup
        .string()
        .trim()
        .required('jquery.validation.field.required, ssp.profile.external.id')
        .test('externalId', 'jquery.validation.externalId',
          value =>
            externalIDValidation.valid(value,
              `/${orgId}/${contactId}/profile/checkexternalId/json?externalId=${value}`)),
    };
  }
  return {};
};
